import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';

import {
  Col,
  CardHeader,
  Row,
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import InnerLoader from '../../../Components/Common/InnerLoader';
import { getTeams } from '../../../actions/promotion/team';
import CreateTeamModal from './CreateTeamModal';

const TeamList = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageOffset, setPageOffset] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [teams, setTeams] = useState([]);
  const [pageSize, setPageSize] = useState(10);

  const [dropdownOpen, setDropdownOpen] = useState({});
  const [direction] = useState('down');

  const getTeamsFunc = async () => {
    try {
      setIsLoading(true);

      const data = {
        pageOffset: pageOffset,
        pageSize: pageSize,
      };
      const res = await getTeams(data);

      setTotalPages(res?.data?.totalPages);
      setTeams(res?.data?.teams || []);
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTeamsFunc();
  }, [pageOffset]);

  const pages = [...Array(totalPages)?.keys()];

  const toggleDropdown = (itemId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [itemId]: !prevState[itemId],
    }));
  };

  return (
    <>
      <Row>
        <Col md={12} className="m-auto">
          <div
            style={{ backdropFilter: ' blur(4px)' }}
            className="position-sticky top-0 z-1 d-flex justify-content-between align-items-center py-4"
          >
            <h4 className="mb-0">Teams</h4>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={12} className="m-auto">
          <table className="table table-nowrap table-centered align-middle mb-0">
            <thead className="bg-light text-muted">
              <tr>
                <th>Name</th>
                <th>Yearly Budget</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {(teams || []).map((team, key) => (
                <tr key={key}>
                  <td>
                    <h5 className="fs-13 mb-1">{team?.teamName}</h5>
                  </td>

                  <td>
                    <h5 className="fs-13 mb-1">{`AED ${team?.yearlyBudget}`}</h5>
                  </td>
                  <td>
                    <Dropdown
                      isOpen={dropdownOpen[team]}
                      toggle={() => toggleDropdown(team)}
                      direction={direction}
                    >
                      <DropdownToggle className="bg-transparent border-0 p-0 shadow-none text-dark ms-auto">
                        <i className="bx bx-dots-horizontal-rounded fs-20"></i>
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem className="fs-13 d-flex align-items-center gap-1">
                          <CreateTeamModal
                            submitHandler={() => {
                              getTeamsFunc();
                            }}
                            team={team}
                          />
                        </DropdownItem>
                        <DropdownItem className="fs-13 d-flex align-items-center gap-1 text-danger">
                          <i className="bx bx-show-alt"></i>
                          View
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div
            style={{ backdropFilter: ' blur(4px)' }}
            className="position-sticky bottom-0 z-1 d-flex justify-content-center align-items-center py-3 border-top"
          >
            <div className="d-flex flex-wrap align-items-start justify-content-center w-100 gap-2">
              <CreateTeamModal
                submitHandler={() => {
                  getTeamsFunc();
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
      {totalPages > 1 ? (
        <div className="align-items-center mt-4 pt-2 justify-content-between row text-center text-sm-start">
          <div className="col-sm"></div>
          <div className="col-sm-auto mt-3 mt-sm-0">
            <ul className="pagination pagination-separated pagination-sm mb-0 justify-content-center">
              <li className={`page-item  ${pageOffset < 1 ? 'disabled' : ''}`}>
                <Link
                  to="#"
                  className="page-link"
                  onClick={() => {
                    setPageOffset(pageOffset - 1);
                  }}
                >
                  ←
                </Link>
              </li>

              {pages?.map((page, index) => {
                return (
                  <li
                    className={`page-item ${
                      pageOffset === index ? 'active' : ''
                    }`}
                  >
                    <Link
                      to="#"
                      className="page-link"
                      onClick={() => setPageOffset(index)}
                    >
                      {index + 1}
                    </Link>
                  </li>
                );
              })}

              <li className="page-item">
                <Link
                  to="#"
                  className={`page-link ${
                    pageOffset >= totalPages - 1 ? 'disabled' : ''
                  }`}
                  onClick={() => {
                    setPageOffset(pageOffset + 1);
                  }}
                >
                  →
                </Link>
              </li>
            </ul>
          </div>
        </div>
      ) : null}
      {isLoading ? <InnerLoader /> : null}
    </>
  );
};

export default TeamList;
